<div class="wrapper">
  <div *ngIf="fromTypeOptions?.length" class="heading text-type-2">
    {{
      fromTypeOptions.length === 1 ? fromTypeOptions[0]?.name + ' Form' : data?.control_form?.label || 'Add a form'
    }}
  </div>
  <app-dropdown
    *ngIf="!isPreview"
    [enableDetailedOptionView]="false"
    [enableSearch]="true"
    [error]="errorMessages['formType']"
    [options]="fromTypeOptions"
    [parentFormGroup]="form"
    class="mb-[20px]"
    controlName="formType"
    label="Form Type"
    placeholder="Search"
  />
  <!--  Header Level Fields-->
  <div *ngIf="headerFields?.length"
       class="header-section-form-fields border-[1px] border-[#E9ECF4] rounded-[4px] px-[12px] pt-[21px] mb-[20px]">
    <ng-container *ngFor="let hf of headerFields; let i = index">
      <ng-container [ngSwitch]="hf?.type">
        <!-- String Type -->
        <ng-container *ngSwitchCase="'string'">
          <ng-container *ngIf="hf?.pick_list; else textInput">
            <!-- Dropdown -->
            <app-dropdown
              [controlName]="hf?.name"
              [enableMultiple]="hf?.multi_select"
              [enableOthers]="!!hf?.allow_other"
              [enableSearch]="true"
              [id]="hf?.name+'_'+ i"
              [label]="hf?.label + (hf?.uom ? ' (' + hf?.uom + ')' : '')"
              [options]="picklistOptions[hf.name]"
              [parentFormGroup]="form"
              [selectionString]="form.controls[hf?.name]?.value?.length > 1 ? hf?.label + 's' : hf.label "
              [showCount]="hf.name === 'item'"
              class="mb-[20px]"
            />
            <ng-container *ngIf="this.form.controls[hf?.name+'_others']">
              <app-text-input
                [controlName]="hf?.name+'_others'"
                [id]="hf?.name+'_others'+ i"
                [label]="hf?.label+' others'"
                [parentFormGroup]="form"
                class="mb-[20px]"
              />
            </ng-container>
          </ng-container>
          <ng-template #textInput>
            <ng-container *ngIf="!hf?.display_only; else displayOnly">
              <!-- Text Input -->
              <app-text-input
                [controlName]="hf?.name"
                [id]="hf?.name+'_'+ i"
                [label]="hf?.label + (hf?.uom ? ' (' + hf?.uom + ')' : '')"
                [parentFormGroup]="form"
                class="mb-[20px]"
              />
            </ng-container>
            <ng-template #displayOnly>
              <!-- View Only Input -->
              <app-view-field
                [id]="hf?.name+'_'+ i"
                [label]="hf?.label + (hf?.uom ? ' (' + hf?.uom + ')' : '')"
                [value]="form?.controls[hf?.name]?.value"
                class="mb-[20px]"
              />
            </ng-template>
          </ng-template>
        </ng-container>
        <ng-container *ngSwitchCase="'number'">
          <ng-container *ngIf="!hf?.display_only; else displayOnly">
            <!-- Number Type -->
            <app-number-input
              [controlName]="hf?.name"
              [id]="hf?.name+'_'+ i"
              [isDecimalAllowed]="true"
              [label]="hf?.label + (hf?.uom ? ' (' + hf?.uom + ')' : '')"
              [parentFormGroup]="form"
              class="mb-[20px]"
            />
          </ng-container>
          <ng-template #displayOnly>
            <!-- View Only Input -->
            <app-view-field
              [id]="hf?.name+'_'+ i"
              [label]="hf?.label + (hf?.uom ? ' (' + hf?.uom + ')' : '')"
              [value]="form?.controls[hf?.name]?.value"
              class="mb-[40px]"
            />
          </ng-template>
        </ng-container>
        <!-- Date Type -->
        <app-date-picker
          *ngSwitchCase="'date'"
          [controlName]="hf?.name"
          [id]="hf?.name+'_'+ i"
          [label]="hf?.label + (hf?.uom ? ' (' + hf?.uom + ')' : '')"
          [parentFormGroup]="form"
          class="mb-[20px]"
        />
        <!-- Time Type -->
        <app-time-select
          *ngSwitchCase="'time'"
          [amPmControlName]="hf?.name+'_am_pm'"
          [controlName]="hf?.name"
          [id]="hf?.name+'_'+ i"
          [label]="hf?.label + (hf?.uom ? ' (' + hf?.uom + ')' : '')"
          [parentFormGroup]="form"
          [timePeriodControlName]="hf?.name+'_timePeriod'"
          class="mb-[20px]"
        />
        <!-- Text Area Type -->
        <app-text-area
          *ngSwitchCase="'textarea'"
          [controlName]="hf?.name"
          [id]="hf?.name+'_'+ i"
          [label]="hf?.label + (hf?.uom ? ' (' + hf?.uom + ')' : '')"
          [parentFormGroup]="form"
          class="mb-[20px]"
        />
        <!-- Boolean -->
        <div
          *ngSwitchCase="'boolean'"
          [id]="hf?.name+'_'+ i"
          class="flex flex-row justify-between items-center mb-[20px] gap-[20px] w-full">
          <div class="label text-type-13 ">
            {{ hf?.label + (hf?.uom ? ' (' + hf?.uom + ')' : '') }}
          </div>
          <mat-slide-toggle
            (change)="onToggle($event, hf?.name)"
            [checked]="form?.controls?.[hf?.name]?.value"
            [disableRipple]="false"
            class="slide-toggle-btn"
            color="primary"
          />
        </div>
      </ng-container>
    </ng-container>
  </div>
  <!--  Add Station-->
  <div
    (click)="openStationPopup()"
    *ngIf="editable && form?.controls?.['formType']?.value && uiConfig?.show_station"
    class="flex flex-row justify-between items-center mb-[20px]"
  >
    <div class="section-heading text-type-8 !text-[#60698b]">Station</div>
    <div class="add-station-block flex flex-row justify-start items-center cursor-pointer w-fit">
      <mat-icon class="icon mr-[5px]" svgIcon="blue-plus" />
      <span class="text-type-9">{{ uiConfig?.add_station_label || 'Add station' }}</span>
    </div>
  </div>
  <!--  Add Entry-->
  <div
    (click)="addEntry()"
    *ngIf="editable && form?.controls?.['formType']?.value && !enableNestedAccordion"
    class="flex flex-row justify-between items-center mb-[20px]"
  >
    <div class="section-heading text-type-8 !text-[#60698b]"></div>
    <div class="add-station-block flex flex-row justify-start items-center cursor-pointer w-fit">
      <mat-icon class="icon mr-[5px]" svgIcon="blue-plus" />
      <span class="text-type-9">{{ uiConfig?.add_line_label || 'Add entry' }}</span>
    </div>
  </div>
  <!-- Nested Accordion -->
  <ng-container *ngIf="enableNestedAccordion">
    <!-- Station Accordion -->
    <div *ngFor="let lineKey of stationLineKeys; let last = last">
      <div [class.is-expanded]="selectedStationId === lineKey?.key"
           [id]="lineKey?.key"
           class="station-accordion mb-[20px]">
        <div class="station-header flex justify-between items-center">
          <div
            (click)="selectStation(lineKey?.key)"
            class="left flex justify-start items-center gap-[12px] grow"
          >
            <div class="details flex flex-col">
              <div class="station-accordion-heading text-type-8">
                {{ lineKey?.stationName }}
              </div>
              <div class="station-accordion-sub-heading text-type-14">
                Average: {{ stationAverageFieldMap?.[lineKey?.key]?.average !== null ? (stationAverageFieldMap?.[lineKey?.key]?.average | number:'1.2-2') : 'N/A' }}
              </div>
            </div>
          </div>
          <div class="right flex justify-center items-center gap-[10px]">
            <div class="chevron">
              <mat-icon
                (click)="selectStation(lineKey?.key)"
                [svgIcon]="selectedStationId === lineKey?.key ? 'chevron-up' : 'chevron-down'"
                class="chevron-icon"
              />
            </div>
            <div *ngIf="editable" class="menu-section">
              <mat-icon
                [matMenuTriggerFor]="menu"
               
                class="menu-icon"
              >
                more_horiz
              </mat-icon>
              <mat-menu #menu="matMenu">
                <button (click)="addTime(lineKey?.key)" mat-menu-item>
                  <mat-icon svgIcon="plus" />
                  {{ uiConfig?.add_line_label || 'Add entry' }}
                </button>
                <button (click)="deleteStationItem(lineKey?.key)" mat-menu-item>
                  <mat-icon svgIcon="trash" />
                  {{ uiConfig?.delete_station_label || 'Delete station' }}
                </button>
              </mat-menu>
            </div>
          </div>
        </div>
        <div class="station-content">
          <ng-container>
            <div class="fields-row input-block grid grid-cols-2 gap-x-[20px] gap-y-[20px]">
              <ng-container *ngFor="let sff of stationBlockFields; let i = index">
                <ng-container [ngSwitch]="sff?.type">
                  <!-- TYPE: STRING -->
                  <ng-container *ngSwitchCase="'string'">
                    <ng-container *ngIf="sff?.name === 'offset_type'; else textInput">
                      <!-- Offset Type → Dropdown -->
                      <app-dropdown
                        [controlName]="sff?.name"
                        [enableMultiple]="sff?.multi_select"
                        [enableSearch]="true"
                        [id]="sff?.name+'_'+ i"
                        [label]="sff?.label"
                        [options]="offsetTypeOptions"
                        [parentFormGroup]="stationFormGroup"
                        class="mb-[20px]">
                      </app-dropdown>
                    </ng-container>

                    <!-- All other string fields → Text Input -->
                    <ng-template #textInput>
                      <app-text-input
                        [controlName]="sff?.name"
                        [id]="sff?.name+'_'+ i"
                        [label]="sff?.label + (sff?.uom ? ' (' + sff?.uom + ')' : '')"
                        [parentFormGroup]="stationFormGroup"
                        class="mb-[20px]">
                      </app-text-input>
                    </ng-template>
                  </ng-container>
                  <!-- Number Type -->
                  <ng-container *ngSwitchCase="'number'">
                    <ng-container *ngIf="!sff?.display_only; else displayOnly">
                      <!-- Number Type -->
                      <app-number-input
                        [controlName]="sff?.name"
                        [id]="sff?.name+'_'+ i"
                        [isDecimalAllowed]="true"
                        [label]="sff?.label + (sff?.uom ? ' (' + sff?.uom + ')' : '')"
                        [parentFormGroup]="stationFormGroup"
                        class="mb-[20px]"
                      />
                    </ng-container>
                    <ng-template #displayOnly>
                      <!-- View Only Input -->
                      <app-view-field
                        [id]="sff?.name+'_'+ i"
                        [label]="sff?.label + (sff?.uom ? ' (' + sff?.uom + ')' : '')"
                        [value]="stationFormGroup?.controls[sff?.name]?.value"
                        class="mb-[40px]"
                      />
                    </ng-template>
                  </ng-container>

                </ng-container>
              </ng-container>
            </div>
            <!-- Time Accordion -->
            <ng-container *ngFor="let tk of timeKeys">
              <div [class.is-expanded]="selectedTimeBlockId === tk?.key"
                   [id]="tk?.key"
                   class="time-accordion border-[1px] border-[#E9ECF4] rounded-[4px] px-[12px] mb-[20px]">
                <div class="time-header flex justify-between items-center">
                  <div
                    (click)="selectTimeBlock(tk?.key)"
                    class="left flex justify-start items-center gap-[12px] grow"
                  >
                    <div class="details flex flex-col">
                      <div class="time-accordion-heading text-type-8">
                        {{ tk?.timeLabel }}
                      </div>
                      <div class="time-accordion-sub-heading text-type-14">
                        {{ averageField?.label }}
                        : {{ stationAverageFieldMap?.[lineKey?.key]?.averageFieldMap?.[tk?.key] ?? 'N/A' }}
                      </div>
                    </div>
                  </div>
                  <div class="right flex justify-center items-center gap-[10px]">
                    <div class="chevron">
                      <mat-icon
                        (click)="selectTimeBlock(tk?.key)"
                        [svgIcon]="selectedTimeBlockId === tk?.key ? 'chevron-up' : 'chevron-down'"
                        class="chevron-icon"
                      />
                    </div>
                    <div *ngIf="editable" class="menu-section">
                      <mat-icon
                        [matMenuTriggerFor]="menu"
                       
                        class="menu-icon"
                      >
                        more_horiz
                      </mat-icon>
                      <mat-menu #menu="matMenu">
                        <button (click)="deleteTime(tk?.key)" mat-menu-item>
                          <mat-icon svgIcon="trash" />
                          {{ uiConfig?.delete_line_label || 'Delete entry' }}
                        </button>
                      </mat-menu>
                    </div>
                  </div>
                </div>
                <div class="time-content">
                  <ng-container>
                    <div class="fields-row input-block grid grid-cols-2 gap-x-[20px] gap-y-[20px]">
                      <ng-container *ngFor="let tbf of timeBlockFields; let i = index">
                        <ng-container [ngSwitch]="tbf?.type">
                          <!-- TYPE: TIME -->
                          <app-time-select
                            *ngSwitchCase="'time'"
                            [controlName]="tbf?.name"
                            [id]="tbf?.name+'_'+ i"
                            [label]="tbf?.label + (tbf?.uom ? ' (' + tbf?.uom + ')' : '')"
                            [parentFormGroup]="timeFormGroup"
                            class="mb-[20px]">
                          </app-time-select>
                          <!-- TYPE: STRING -->
                          <app-text-input
                            *ngSwitchCase="'string'"
                            [controlName]="tbf?.name"
                            [id]="tbf?.name+'_'+ i"
                            [label]="tbf?.label + (tbf?.uom ? ' (' + tbf?.uom + ')' : '')"
                            [parentFormGroup]="timeFormGroup"
                            class="mb-[20px]">
                          </app-text-input>
                          <!-- Number Type -->
                          <ng-container *ngSwitchCase="'number'">
                            <ng-container *ngIf="!tbf?.display_only; else displayOnly">
                              <!-- Number Type -->
                              <app-number-input
                                [controlName]="tbf?.name"
                                [id]="tbf?.name+'_'+ i"
                                [isDecimalAllowed]="true"
                                [label]="tbf?.label + (tbf?.uom ? ' (' + tbf?.uom + ')' : '')"
                                [parentFormGroup]="timeFormGroup"
                                class="mb-[20px]"
                              />
                            </ng-container>
                            <ng-template #displayOnly>
                              <!-- View Only Input -->
                              <app-view-field
                                [id]="tbf?.name+'_'+ i"
                                [label]="tbf?.label + (tbf?.uom ? ' (' + tbf?.uom + ')' : '')"
                                [value]="timeFormGroup?.controls[tbf?.name]?.value"
                                class="mb-[40px]"
                              />
                            </ng-template>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                    </div>
                  </ng-container>
                  <app-pictures-section
                    (onDelete)="deletePicture($event)"
                    *ngIf="selectedMediaFiles?.length"
                    [isEditable]="editable"
                    [pictures]="selectedMediaFiles"
                    class="pictures-section mb-[40px]"
                  />
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>
      <hr *ngIf="!last" class="hr mb-[20px]">
    </div>
  </ng-container>
  <!-- Lines Accordion -->
  <ng-container *ngIf="!enableNestedAccordion">
    <div *ngFor="let lineKey of lineKeys; let last = last">
      <div [class.is-expanded]="selectedLineId === lineKey?.key"
           [id]="lineKey?.key"
           class="line-accordion mb-[20px]">
        <div class="line-header flex justify-between items-center">
          <div
            (click)="selectLine(lineKey?.key)"
            class="left flex justify-start items-center gap-[12px] grow"
          >
            <div class="details flex flex-col">
              <div class="line-accordion-heading text-type-8">
                {{ lineKey?.lineName }}
              </div>
            </div>
          </div>
          <div class="right flex justify-center items-center gap-[10px]">
            <div class="chevron">
              <mat-icon
                (click)="selectLine(lineKey?.key)"
                [svgIcon]="selectedLineId === lineKey?.key ? 'chevron-up' : 'chevron-down'"
                class="chevron-icon"
              />
            </div>
            <div *ngIf="editable" class="menu-section">
              <mat-icon
                [matMenuTriggerFor]="menu"
               
                class="menu-icon"
              >
                more_horiz
              </mat-icon>
              <mat-menu #menu="matMenu">
                <button (click)="deleteLineEntry(lineKey?.key)" mat-menu-item>
                  <mat-icon svgIcon="trash" />
                  {{ uiConfig?.delete_line_label || 'Delete entry' }}
                </button>
              </mat-menu>
            </div>
          </div>
        </div>
        <div class="line-content">
          <ng-container>
            <div class="fields-row input-block grid grid-cols-2 gap-x-[20px] gap-y-[20px]">
              <ng-container *ngFor="let lf of lineFields; let i = index">
                <ng-container [ngSwitch]="lf?.type">
                  <!-- String Type -->
                  <ng-container *ngSwitchCase="'string'">
                    <ng-container *ngIf="lf?.pick_list; else textInput">
                      <!-- Dropdown -->
                      <app-dropdown
                        [controlName]="lf?.name"
                        [enableMultiple]="lf?.multi_select"
                        [enableOthers]="!!lf?.allow_other"
                        [enableSearch]="true"
                        [id]="lf?.name+'_'+ i"
                        [label]="lf?.label + (lf?.uom ? ' (' + lf?.uom + ')' : '')"
                        [options]="picklistOptions[lf.name]"
                        [parentFormGroup]="lineFormGroup"
                        class=""
                      />
                      <ng-container *ngIf="this.form.controls[lf?.name+'_others']">
                        <app-text-input
                          [controlName]="lf?.name+'_others'"
                          [id]="lf?.name+'_others'+ i"
                          [label]="lf?.label+' others'"
                          [parentFormGroup]="lineFormGroup"
                          class=""
                        />
                      </ng-container>
                    </ng-container>
                    <ng-template #textInput>
                      <!-- Text Input -->
                      <app-text-input
                        [controlName]="lf?.name"
                        [id]="lf?.name+'_'+ i"
                        [label]="lf?.label + (lf?.uom ? ' (' + lf?.uom + ')' : '')"
                        [parentFormGroup]="lineFormGroup"
                        class=""
                      />
                    </ng-template>
                  </ng-container>
                  <!-- Number Type -->
                  <app-number-input
                    *ngSwitchCase="'number'"
                    [controlName]="lf?.name"
                    [id]="lf?.name+'_'+ i"
                    [isDecimalAllowed]="true"
                    [label]="lf?.label + (lf?.uom ? ' (' + lf?.uom + ')' : '')"
                    [parentFormGroup]="lineFormGroup"
                    class=""
                  />
                  <!-- Date Type -->
                  <app-date-picker
                    *ngSwitchCase="'date'"
                    [controlName]="lf?.name"
                    [id]="lf?.name+'_'+ i"
                    [label]="lf?.label + (lf?.uom ? ' (' + lf?.uom + ')' : '')"
                    [parentFormGroup]="lineFormGroup"
                    class=""
                  />
                  <!-- Time Type -->
                  <app-time-select
                    *ngSwitchCase="'time'"
                    [amPmControlName]="lf?.name+'_am_pm'"
                    [controlName]="lf?.name"
                    [id]="lf?.name+'_'+ i"
                    [label]="lf?.label + (lf?.uom ? ' (' + lf?.uom + ')' : '')"
                    [parentFormGroup]="lineFormGroup"
                    [timePeriodControlName]="lf?.name+'_timePeriod'"
                    class=""
                  />
                  <!-- Text Area Type -->
                  <app-text-area
                    *ngSwitchCase="'textarea'"
                    [controlName]="lf?.name"
                    [id]="lf?.name+'_'+ i"
                    [label]="lf?.label + (lf?.uom ? ' (' + lf?.uom + ')' : '')"
                    [parentFormGroup]="lineFormGroup"
                    class=" col-span-2"
                  />
                  <!-- Boolean -->
                  <div
                    *ngSwitchCase="'boolean'"
                    [id]="lf?.name+'_'+ i"
                    class="flex flex-row justify-between items-center  gap-[20px] w-full col-span-2">
                    <div class="label text-type-13 ">
                      {{ lf?.label + (lf?.uom ? ' (' + lf?.uom + ')' : '') }}
                    </div>
                    <mat-slide-toggle
                      (change)="onToggle($event, lf?.name)"
                      [checked]="lineFormGroup?.controls?.[lf?.name]?.value"
                      [disableRipple]="false"
                      class="slide-toggle-btn"
                      color="primary"
                    />
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </ng-container>
          <app-pictures-section
            (onDelete)="deletePicture($event)"
            *ngIf="selectedMediaFiles?.length"
            [isEditable]="editable"
            [pictures]="selectedMediaFiles"
            class="pictures-section mb-[40px]"
          />
        </div>
      </div>
      <hr *ngIf="!last" class="hr mb-[20px]">
    </div>
  </ng-container>
  <!--  Footer Level Fields-->
  <div *ngIf="footerFields?.length"
       class="footer-section-form-fields border-[1px] border-[#E9ECF4] rounded-[4px] px-[12px] pt-[21px] mb-[20px]">
    <ng-container *ngFor="let ff of footerFields; let i = index">
      <ng-container [ngSwitch]="ff?.type">

        <!-- String Type -->
        <app-text-input
          *ngSwitchCase="'string'"
          [controlName]="ff?.name"
          [id]="ff?.name+'_'+ i"
          [label]="ff?.label + (ff?.uom ? ' (' + ff?.uom + ')' : '')"
          [parentFormGroup]="form"
          class="mb-[20px]">
        </app-text-input>

        <!-- Number Type -->
        <ng-container *ngSwitchCase="'number'">
          <ng-container *ngIf="!ff?.display_only; else displayOnly">
            <!-- Number Type -->
            <app-number-input
              [controlName]="ff?.name"
              [id]="ff?.name+'_'+ i"
              [isDecimalAllowed]="true"
              [label]="ff?.label + (ff?.uom ? ' (' + ff?.uom + ')' : '')"
              [parentFormGroup]="form"
              class="mb-[20px]"
            />
          </ng-container>
          <ng-template #displayOnly>
            <!-- View Only Input -->
            <app-view-field
              [id]="ff?.name+'_'+ i"
              [label]="ff?.label + (ff?.uom ? ' (' + ff?.uom + ')' : '')"
              [value]="form?.controls[ff?.name]?.value"
              class="mb-[40px]"
            />
          </ng-template>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>

  <!-- Signature Section (gated on ui_config.display_signatures) -->
  <div
    *ngIf="displaySignature"
    class="signature-section mb-[40px]"
  >
    <div class="signature-section-label">Signature:</div>
    <div
      *ngIf="signatureViews?.length"
      class="signatures flex flex-col justify-start"
    >
      <div
        *ngFor="let sv of signatureViews"
        class="eachSignature"
      >
        <div
          (click)="openSignatureDetails(sv.sourceIndex)"
          class="signature-content"
        >
          <div class="role">{{ sv.role || 'Signature' }}</div>
          <!-- Drawn signature: render the captured image, bounded. -->
          <ng-container *ngIf="sv.method === 'drawn' && sv.imageUrl; else nonDrawn">
            <img
              [src]="sv.imageUrl"
              [alt]="(sv.role || 'Signature') + ' signature'"
              class="signature-image"
            />
          </ng-container>
          <ng-template #nonDrawn>
            <!-- Typed-with-font: best-effort render in the chosen font. -->
            <div
              *ngIf="sv.method === 'typed_font' && sv.text; else plainSignature"
              [style.font-family]="sv.fontFamily"
              class="signature-name signature-name--font"
            >{{ sv.text }}
            </div>
            <ng-template #plainSignature>
              <!-- Typed / legacy / drawn-without-image: plain text fallback. -->
              <div class="signature-name">{{ sv.text || 'Signed' }}</div>
            </ng-template>
          </ng-template>
          <div *ngIf="sv.signedAt" class="signature-signed-at">Signed {{ sv.signedAt }}</div>
        </div>
        <mat-icon
          *ngIf="editable"
          (click)="removeSignature(sv.sourceIndex)"
          class="signature-remove"
          svgIcon="trash"
        />
      </div>
    </div>
    <div
      *ngIf="editable"
      (click)="openSignatureDetails(null)"
      class="signature flex flex-row flex-wrap justify-start items-center"
    >
      <mat-icon class="add-icon mr-[8px]" svgIcon="plus" />
      Add Signature
    </div>
  </div>

  <div
    *ngIf="displayCommentSection"
    class="comment-section mb-[40px]"
  >
    <app-text-area
      [parentFormGroup]="form"
      controlName="comment"
      label="COMMENT"
    />
  </div>
  <app-pictures-section
    (onDelete)="deletePicture($event)"
    *ngIf="mediaFiles?.length"
    [isEditable]="editable"
    [pictures]="mediaFiles"
    class="pictures-section mb-[40px]"
  />
  <app-location-station-card
    (onDelete)="deleteLocation()"
    *ngIf="showLocationSection()"
    [isEditable]="editable"
    [latitude]="form?.controls?.latitude?.value"
    [longitude]="form?.controls?.longitude?.value"
    [form]="form"
    [recordLabel]="'form'"
    class="location-section mb-[40px]"
  />
</div>
